import type { BadgeTone } from "../design-system/Badge";
import type { HealthStatus, DecisionPriority } from "../ipc/types";
import { strings } from "../i18n/es-CL";

export function healthTone(status: HealthStatus): BadgeTone {
  switch (status) {
    case "healthy":
      return "success";
    case "degraded":
      return "warning";
    case "critical":
      return "danger";
  }
}

export function healthLabel(status: HealthStatus): string {
  return strings.health[status];
}

export function priorityTone(priority: DecisionPriority): BadgeTone {
  switch (priority) {
    case "low":
      return "neutral";
    case "medium":
      return "info";
    case "high":
      return "warning";
    case "critical":
      return "danger";
  }
}

const PRIORITY_LABEL: Record<DecisionPriority, string> = {
  low: "Baja",
  medium: "Media",
  high: "Alta",
  critical: "Crítica",
};

export function priorityLabel(priority: DecisionPriority): string {
  return PRIORITY_LABEL[priority];
}
